import { render, staticRenderFns } from "./base-footer.vue?vue&type=template&id=0983766f&scoped=true"
import script from "./base-footer.vue?vue&type=script&lang=js"
export * from "./base-footer.vue?vue&type=script&lang=js"
import style0 from "./base-footer.vue?vue&type=style&index=0&id=0983766f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983766f",
  null
  
)

export default component.exports